import React from "react";
import { Typography, Input, Tag, Checkbox } from "antd";
import ApprovedStatusSelect from "../../../components/util/ApprovedStatusSelect";
import moment from "moment";
const { Text } = Typography;

const getDayCenterPatientColumns = (
  intl,
  handleChanges,
  changes,
  effectiveOrders,
  hasEditorPermission
) => {
  const isDateInOrderPeriod = (date) => {
    return effectiveOrders?.some((order) => {
      const effectiveFrom = moment(order.effective_from);
      const effectiveTo = order.effective_to
        ? moment(order.effective_to)
        : null;

      return (
        date.isSameOrAfter(effectiveFrom, "day") &&
        (!effectiveTo || date.isSameOrBefore(effectiveTo, "day"))
      );
    });
  };

  return [
    {
      title: intl.formatMessage({
        id: "app.patients.date",
      }),
      dataIndex: "date",
      width: "100px",
      render(text, record) {
        return (
          <Text style={{ padding: " 0 12px" }}>
            {moment(text).format("DD")}
          </Text>
        );
      },
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.dayInWeek",
      }),
      width: "70px",
      ellipsis: true,
      dataIndex: "date",
      render(text, record) {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
    },
    {
      title: intl.formatMessage({ id: "app.patients.present" }),
      dataIndex: "id",
      width: "120px",
      render(text, record) {
        const dayOfMonth = moment(record.date).date();
        const initialValue = record.day_center_approved_info;
        const approvedStatus =
          changes[dayOfMonth]?.day_center_approved_info ?? initialValue;
        const isDisabled =
          moment(record.date).isAfter(moment(), "day") ||
          !isDateInOrderPeriod(moment(record.date)) ||
          !hasEditorPermission;

        return (
          <ApprovedStatusSelect
            popupContainer={document.getElementById("dayCenterTableRef")}
            value={approvedStatus}
            onChange={(val) => {
              handleChanges(dayOfMonth, "day_center_approved_info", val);
              handleChanges(dayOfMonth, "present", val !== 4);
            }}
            disabled={isDisabled}
          />
        );
      },
    },

    {
      title: intl.formatMessage({
        id: "app.patients.day_center_half_day",
      }),
      dataIndex: "day_center_half_day",
      width: "120px",
      render(text, record) {
        const dayOfMonth = moment(record.date).date();
        const isDisabled =
          moment(record.date).isAfter(moment(), "day") ||
          !isDateInOrderPeriod(moment(record.date)) ||
          !hasEditorPermission;
        return (
          <Checkbox
            checked={changes[dayOfMonth]?.day_center_half_day}
            onChange={(e) =>
              handleChanges(dayOfMonth, "day_center_half_day", e.target.checked)
            }
            disabled={isDisabled}
            style={{ margin: "20px 0" }}
          />
        );
      },
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.status",
      }),
      dataIndex: "approved",
      width: "80px",
      render(text, record) {
        const status = record.day_center_approved_info;
        return record.approved ? (
          <Tag color="success">
            {intl.formatMessage({
              id: "app.scheduling.table.verified",
            })}
          </Tag>
        ) : null;
      },
    },
    {
      title: intl.formatMessage({ id: "app.patients.comment" }),
      dataIndex: "comment",
      render(text, record) {
        const dayOfMonth = moment(record.date).date();
        const isDisabled =
          moment(record.date).isAfter(moment(), "day") ||
          !isDateInOrderPeriod(moment(record.date)) ||
          !hasEditorPermission;

        return (
          <Input
            style={{ minWidth: "120px" }}
            value={changes[dayOfMonth]?.comment ?? text}
            onChange={(e) =>
              handleChanges(dayOfMonth, "comment", e.target.value)
            }
            disabled={isDisabled}
          />
        );
      },
    },
  ];
};

export default getDayCenterPatientColumns;
